import styled from "@emotion/styled";
import MUISkeleton from "@mui/material/Skeleton";
import { Breakpoints, mq } from "src/helpers/mediaQuery";

import isMobile from "../../../helpers/isMobile";

const Consents = styled(MUISkeleton)`
  border-radius: 28px;
  margin-left: 12px;
  transform: unset;
`;

const Text = styled(MUISkeleton)`
  transform: unset;
  margin-bottom: 12px;
  border-radius: 12px;
`;

function ArticleContent({ className }) {
	if (isMobile()) {
		return (
			<div className={className}>
				<Text height={60} />
				<Text height={60} />
				<Text height={60} />
			</div>
		);
	}

	return (
		<div className={className}>
			<div>
				<div>
					<Text height={60} />
					<Text height={60} />
				</div>
				<Consents height={160} width={360} />
			</div>
		</div>
	);
}

export default styled(ArticleContent)`
  height: 100%;
  max-width: 1200px;
  margin-top: 30px;

  > div:first-of-type {
    display: flex;

    > div:last-of-type {
      flex: 1;
    }
  }

  ${mq(Breakpoints.sm)} {
    flex-direction: column;
    padding: 4px;
    margin-top: 12px;
  }
`;
